module.exports = __webpack_public_path__ + "static/media/010.4e1183ad.jpg";